import { useCallback } from 'react';

/**
 * Ritorna una funzione che gestisce il cambiamento del riferimento
 * del dropdown di un componente Select.
 * Questa funzione imposta l'attributo `aria-multiselectable`
 * su `true` se il modo di selezione è 'multiple' o 'tags'.
 */
export function useOnSelectDropdownRefChange(
  mode: 'multiple' | 'tags' | undefined,
) {
  return useCallback(
    (node: HTMLDivElement | null) => {
      if (!node) return;
      const listbox = node.querySelector('[role="listbox"]');
      if (!listbox) return;
      if (mode === 'multiple' || mode === 'tags') {
        listbox.ariaMultiSelectable = 'true';
      }
    },
    [mode],
  );
}
